type Provider = 'gigya' | 'zitadel'

interface Config {
  version: string
  release: string
  env: 'test' | 'development' | 'production'
  sentry: {
    enabled: boolean
    dsn: string
  }
  api: {
    distribusion: ApiUrl
    railAgent: ApiUrl
    portal: ApiUrl
    suggestionUrl: string
    translationsUrl: string
    loyaltyUrl: string
    usersUrl: string
  }
  searchResultUrl: string
  portalPageUrl: string
  publicPath: string
  searchBarDateRange: number
  trackTripMaxDaysOffset: number
  destinationsPageSize: number
  defaultDepartureTime: string
  maxPassengers: number
  amtrakMaxPassengers: number
  expressMaxPassengers: number
  googleMapsPublicKey: string
  gigyaRpnApiKey: Record<number, string>
  googleMapsRealtimeVisualizerMapId: string
  dayShift: number
  bookingStatus: {
    timeout: number
    maxAttempts: number
  }
  activationStatus: {
    timeout: number
    maxAttempts: number
  }
  checkoutUrl: {
    old: string
    new: string
  }
  reservationStatus: {
    timeout: number
    maxAttempts: number
  }
  currencyMultiplier: Record<Currency, number>
  amplitudeApiKey: string
  adyen: {
    env: string
    publicKey: string
    description: string
  }
  vgs: {
    vaultId: string
    routeId: string
    env: 'sandbox' | 'live'
  }
  auth: {
    baseUrl: string
  }
  fallback: {
    currency: {
      supported: Currency[]
      default: Currency
    }
    locale: {
      supported: Locale[]
      default: Locale
    }
    pax: number
    lastName: string
  }
  resolve: {
    retailerPartnerNumber: Record<string, number>
    searchResultUrl: Record<string, string>
    checkoutPageUrl: Record<string, string>
  }
  scripts: {
    enabled: boolean
  }
  settings: {
    topCurrencies: Currency[]
    topCountries: string[]
  }
  suggestions: Record<string, { filter: { byCountries: string[]; byCities: string[] } }>
  fareSplitViewLength: number
  validityBlacklistedTypes: string[]
  retailerDiscounts: Record<number, { supportedPassengers?: string[]; discounts?: string[] }>
  passengersValidity: {
    byRpn: Record<string, { required: string[]; check: string[]; relation: string } | undefined>
  }
  expressCheckout: {
    carriersWithAnyDirectionTrips: string[]
  }
  cardsLimit: number
  forcedFareClass: ForcedFareClass.Entity
  forcedExtras: Record<string, { seatSelection?: { enabled: boolean }; testAncillaries?: { enabled: boolean } }>
  priceCalendarDateRange: number
  accommodation: Record<Partners, Record<Locale | 'default', string>>
  distribusionDomain: string
  ancillaryLimitation: Record<string, Record<string, number>>
  twoStepSearch: {
    byRpn: number[]
    byRpnAndCarrier: Record<string, string[]>
  }
  amendments: {
    avoidVacancy: Record<'byRpn', number[]>
  }
  connectionsSearch: Record<string, Record<'weekly' | 'default', string>>
  subscriptionStart: Record<string, Record<string, number>>
  accountCreation: Record<'byRpn', number[]>
  userAccountByProvider: Record<Provider, Record<'rpn', number[]>>
  seatAncillaryAsSelection: Record<string, boolean>
  seatAncillaryCarriers: string[]
  dlocal: {
    publicKey: string
    scriptSrc: string
    env: 'sandbox' | 'production'
    smartFieldKey: string
    deviceCollectorUrl: string
  }
  checkoutcom: {
    env: 'production' | 'sandbox'
    publicKey: string
    riskSdk: {
      url: string
      integrity: string
    }
  }
  mercadopago: {
    securityScript: {
      url: string
    }
  }
  estrellaBlancaRPNs: number[]
  subscriptionCountriesPerRpn: Record<number, string[]>
  maxStopOverStationsCount: number
  sendEventToParentWindow: {
    byRpn: number[]
  }
  customGEBUI: {
    byRPN: number[]
  }
  abTests: Record<string, ABTests.Matcher>
}

// eslint-disable-next-line @typescript-eslint/naming-convention
declare let __CONFIG__: Config

const config = { ...__CONFIG__ }

export default config
